<div class="gmap h-100" #gmap></div>

<div #layersButton class="bg-white mt-1 ml-1 rounded-md shadow-md"
(mouseover)="over()"
(mouseout)="out()"
>
    <button type="button" mat-raised-button color="primary" (click)="setEditMode()">
        <mat-icon svgIcon="heroicons_outline:square-3-stack-3d"></mat-icon>
    </button>
</div>


<div id="layerController" #layers class="flex flex-col absolute ml-2 mt-8 bg-white  p-2 rounded-md shadow-md" [ngClass]="{'hidden': status=='out'}"
(mouseover)="over()"
(mouseout)="out()"

>
    <div class="flex font-semibold">Basi</div>
    <ng-container *ngFor="let base of BaseMaps">
        <div>
            <input type="radio"  [(ngModel)]="baseMap" [value]="base.id" (change)="setBaseMap(base.id)">
            <label class="ml-2" >{{base.title}}</label>
        </div>
    </ng-container>

    <div class="flex font-semibold">Livelli</div>
    <ng-container *ngFor="let overlay of wmsLayers">
        <div class=" flex items-center gap-3">
            <input type="checkbox" [(ngModel)]="layerStatus[overlay.id]" (ngModelChange)="setOverlay()">
            <label for="toggleTraffic">{{overlay.title}}</label>
        </div>
    </ng-container>


</div>




<!--usato in provincia sp-->
<div *ngIf="false" #infoEdit >

    <button *ngIf="!editMode"  class="bg-white mb-2 ml-2 rounded-md shadow-md"  type="button" mat-raised-button color="primary" (click)="setEditMode()">
        <mat-icon  svgIcon="heroicons_outline:pencil-square"></mat-icon>
    </button>

    <div *ngIf="editMode"  class="bg-white mb-2 ml-2 rounded-md shadow-md" >
        <button type="button" class="p-1" mat-raised-button color="primary" (click)="cancelPosition()">
            <mat-icon svgIcon="heroicons_outline:x-circle"></mat-icon>
        </button>

        <span class="p-1">{{marker?.position?.lat | number: '2.5'}}</span>
        <span class="p-1">{{marker?.position?.lng | number: '1.5'}}</span>

        <button type="button" class="p-1" mat-raised-button color="primary" (click)="savePosition()">
            <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
        </button>
    </div>

</div>

